import { useEffect, useState } from "react";
import { getToast, subscribeToast, clearToast } from "@/lib/toast";

/**
 * AppToast — невеликий тост знизу екрана, без кнопки, авто-зникає через 3с.
 * Монтується в корені (App). Керується через showToast(...) з lib/toast.
 */
export function AppToast() {
  const [state, setState] = useState(getToast());
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeToast(() => setState(getToast())), []);

  useEffect(() => {
    if (!state) {
      setVisible(false);
      return;
    }
    // показати → за 3с сховати → ще 250мс на анімацію → очистити
    setVisible(true);
    const hide = setTimeout(() => setVisible(false), 3000);
    const clear = setTimeout(() => clearToast(), 3250);
    return () => {
      clearTimeout(hide);
      clearTimeout(clear);
    };
  }, [state?.id]);

  if (!state) return null;

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-[12%] z-[10050] flex justify-center px-6"
      aria-live="polite"
    >
      <div
        className={
          "flex items-center gap-2 rounded-full bg-dark px-4 py-2.5 text-[0.8125rem] font-display font-semibold text-white shadow-ai-card transition-all duration-250 " +
          (visible
            ? "translate-y-0 opacity-100"
            : "translate-y-3 opacity-0")
        }
      >
        {state.emoji && <span>{state.emoji}</span>}
        {state.message}
      </div>
    </div>
  );
}
